<template class="roombox">
  <div class="roombox" v-if="room">
    <div class="header">
      <div class="backbtn" @click="backhome()">
        <van-icon name="arrow-left" color="#fff" size=".5rem" />
      </div>
      <div class="room-name">{{ room.lottery.title }} - {{ room.title }}</div>
      <div class="kefu-btn" @click="openKefu">
        <van-icon name="service-o" color="#fff" size="18" />
        <span>客服</span>
      </div>
    </div>
    <div class="panel" v-if="opendata" v-show="panelShow" :class="{ 'info-open': infoShow, 'hist-open': openlist }">
      <div class="sbf">
        <div class="item">
          <div class="nextexpect">
            第<b>{{ opendata.nextexpect }}</b>期开奖
          </div>
          <div class="rest-status" v-if="isResting">
            <span class="rest-text">休息中</span>
            <span class="rest-open">{{ restOpenLabel }}</span>
          </div>
          <div class="cutdown" v-else>
            <van-count-down
              v-if="opendata.timeout > room.ftime"
              :time="parseInt(opendata.timeout) * 1000"
              format="mm:ss"
            />
            <b v-else-if="opendata.timeout <= room.ftime && opendata.timeout > 0">封盘中</b>
            <b v-else>开奖中</b>
          </div>
        </div>
        <div class="item balance-item">
          <div class="title1" @click.stop="toggleInfo">
            <span>账户余额</span>
            <van-icon
              class="bal-refresh"
              name="replay"
              size="12"
              @click.stop="getLottery"
            />
          </div>
          <div class="wallet" @click.stop="toggleInfo">{{ displayBalance }}</div>
        </div>
      </div>
      <div class="info-bar" v-show="infoShow">
        <div class="info-cell">
          <div class="info-label">余额</div>
          <div class="info-val">{{ fmtMoney(userStats.balance) }}</div>
        </div>
        <div class="info-cell">
          <div class="info-label">流水</div>
          <div class="info-val">{{ fmtMoney(userStats.flow) }}</div>
        </div>
        <div class="info-cell">
          <div class="info-label">今日输赢</div>
          <div class="info-val" :class="userStats.today_win >= 0 ? 'up' : 'down'">{{ fmtMoney(userStats.today_win) }}</div>
        </div>
        <div class="info-cell">
          <div class="info-label">回水</div>
          <div class="info-val">{{ fmtMoney(userStats.rebate) }}</div>
        </div>
      </div>
      <div class="xbf-wrap">
        <div class="xbf" :class="{ open: openlist }" @click="toggleHistory">
          <div class="lastexpect">
            第 <b>{{ opendata.expect }}</b>期开奖
          </div>
          <!-- 28：蓝球 + 红特码 + 文字大小单双 + 三角 -->
          <div class="open-balls" v-if="room.lottery.type == 2 && opendata.last && opendata.last.extend">
            <em>{{ opendata.last.extend[0][0] }}</em>
            <i>+</i>
            <em>{{ opendata.last.extend[0][1] }}</em>
            <i>+</i>
            <em>{{ opendata.last.extend[0][2] }}</em>
            <i>=</i>
            <b>{{ opendata.last.extend[1] }}</b>
          </div>
          <strong class="combo-text" v-if="room.lottery.type == 2 && opendata.last && opendata.last.extend">
            {{ temaSize(opendata.last.extend[1]) }}{{ temaOddEven(opendata.last.extend[1]) }}
          </strong>
          <div class="opencode l6hcode" v-else-if="room.lottery.type == 1">
            <div>
              <div class="ball" :class="opendata.last.extend[0][1]">{{ opendata.last.extend[0][0] }}</div>
              <p>{{ opendata.last.extend[0][2] }}/{{ opendata.last.extend[0][3] }}</p>
            </div>
            <div>
              <div class="ball" :class="opendata.last.extend[1][1]">{{ opendata.last.extend[1][0] }}</div>
              <p>{{ opendata.last.extend[1][2] }}/{{ opendata.last.extend[1][3] }}</p>
            </div>
            <div>
              <div class="ball" :class="opendata.last.extend[2][1]">{{ opendata.last.extend[2][0] }}</div>
              <p>{{ opendata.last.extend[2][2] }}/{{ opendata.last.extend[2][3] }}</p>
            </div>
            <div>
              <div class="ball" :class="opendata.last.extend[3][1]">{{ opendata.last.extend[3][0] }}</div>
              <p>{{ opendata.last.extend[3][2] }}/{{ opendata.last.extend[3][3] }}</p>
            </div>
            <div>
              <div class="ball" :class="opendata.last.extend[4][1]">{{ opendata.last.extend[4][0] }}</div>
              <p>{{ opendata.last.extend[4][2] }}/{{ opendata.last.extend[4][3] }}</p>
            </div>
            <div>
              <div class="ball" :class="opendata.last.extend[5][1]">{{ opendata.last.extend[5][0] }}</div>
              <p>{{ opendata.last.extend[5][2] }}/{{ opendata.last.extend[5][3] }}</p>
            </div>
            <div>+</div>
            <div>
              <div class="ball" :class="opendata.last.extend[6][1]">{{ opendata.last.extend[6][0] }}</div>
              <p>{{ opendata.last.extend[6][2] }}/{{ opendata.last.extend[6][3] }}</p>
            </div>
          </div>
          <i class="result-caret"></i>
        </div>
        <!-- 加拿大28：下拉历史（贴在开奖条下方） -->
        <div class="hist-panel" v-if="room.lottery.type == 2 && openlist" @click.stop>
          <div class="hist-tools">
            <span
              class="ht"
              v-for="n in histLimits"
              :key="'hl' + n"
              :class="{ on: histLimit === n }"
              @click.stop="histLimit = n"
            >{{ n }}</span>
          </div>
          <div class="hist-head">
            <span>期号</span><span>结果</span><span>大小</span><span>单双</span><span>极值</span><span>形态</span><span>尾</span>
          </div>
          <div class="hist-row" v-for="item in histList" :key="'ol' + item.expect">
            <span class="period">第{{ shortExpect(item.expect) }}</span>
            <span class="result">
              <em>{{ histN(item, 0) }}</em><i>+</i>
              <em>{{ histN(item, 1) }}</em><i>+</i>
              <em>{{ histN(item, 2) }}</em><i>=</i>
              <b :class="temaHotCool(histTema(item))">{{ pad2(histTema(item)) }}</b>
            </span>
            <strong :class="sizeColor(histTema(item))">{{ temaSize(histTema(item)) }}</strong>
            <strong :class="temaColor(histTema(item))">{{ temaOddEven(histTema(item)) }}</strong>
            <span class="extreme" :style="{ color: extremeColor(histExtreme(item)) }">{{ histExtreme(item) }}</span>
            <span class="shape" :style="{ color: shapeColor(histPattern(item)) }">{{ histPattern(item) }}</span>
            <span class="tail">{{ histTail(item) }}</span>
          </div>
          <div class="hist-empty" v-if="!histList.length">暂无开奖记录</div>
        </div>
      </div>
    </div>

    <div class="chat-wrap" :class="{ 'with-side': fabPos === 'side' }">
      <div class="chatbox" id="chatbox" @scroll="onChatScroll">
        <div
          class="message"
          :class="[i.left == 0 ? 'mine' : '', isSysMsg(i) ? 'sys' : '']"
          v-for="(i, idx) in chatdata"
          :key="'m' + idx + '-' + (i.id || i.content)"
        >
          <div class="avatar">
            <img :src="displayAvatar(i)" onerror="this.src='/static/img/lottery/system.svg'" />
          </div>
          <div class="content" :class="{ 'kk-rich': !!kkCardOf(i) }">
            <p class="nickname">{{ displayAuthor(i) }}</p>
            <div class="msg-body welcome-line" v-if="!kkCardOf(i) && isWelcomeMsg(i)">
              <span class="welcome-ico">📢</span>
              <span>{{ welcomeText(i) }}</span>
            </div>
            <div class="msg-body" v-else-if="!kkCardOf(i)">{{ i.content }}</div>
            <!-- KK 走势表 -->
            <div class="kk-card kk-trend" v-else-if="kkCardOf(i).card === 'trend'">
              <div class="kk-trend-head">
                <span>期数</span><span>开奖号</span><span>特</span><span>大小</span><span>单双</span><span>组合</span>
              </div>
              <div class="kk-trend-row" v-for="(r, ri) in kkCardOf(i).rows" :key="'tr' + ri">
                <span class="te">{{ shortExpect(r.expect) }}</span>
                <span class="nums">
                  <i :class="ballWave(r.n1)">{{ r.n1 }}</i>
                  <i :class="ballWave(r.n2)">{{ r.n2 }}</i>
                  <i :class="ballWave(r.n3)">{{ r.n3 }}</i>
                </span>
                <span class="tema" :class="ballWave(r.tema)">{{ r.tema }}</span>
                <span class="tg" :class="r.size === '大' ? 'red' : 'blue'">{{ r.size }}</span>
                <span class="tg" :class="r.oe === '单' ? 'blue' : 'red'">{{ r.oe }}</span>
                <span class="tg" :class="comboTagClass(r.combo)">{{ r.combo }}</span>
              </div>
            </div>
            <!-- KK 历史开奖 + 近20期 -->
            <div class="kk-card kk-draw" v-else-if="kkCardOf(i).card === 'draw'">
              <div class="kk-draw-title">第 {{ kkCardOf(i).expect }} 期 历史开奖</div>
              <div class="kk-draw-line">
                <i class="ball-sm" :class="ballWave(kkCardOf(i).n1)">{{ kkCardOf(i).n1 }}</i>
                <em>+</em>
                <i class="ball-sm" :class="ballWave(kkCardOf(i).n2)">{{ kkCardOf(i).n2 }}</i>
                <em>+</em>
                <i class="ball-sm" :class="ballWave(kkCardOf(i).n3)">{{ kkCardOf(i).n3 }}</i>
                <em>=</em>
                <i class="ball" :class="ballWave(kkCardOf(i).tema)">{{ kkCardOf(i).tema }}</i>
              </div>
              <div class="kk-draw-tags">
                <span
                  class="tag"
                  v-for="(t, ti) in kkCardOf(i).tags"
                  :key="'tg' + ti"
                  :class="tagClass(t)"
                >{{ t }}</span>
              </div>
              <div class="kk-hist-label">历史20期</div>
              <div class="kk-hist20">
                <span
                  v-for="(h, hi) in kkCardOf(i).hist20"
                  :key="'h' + hi"
                  :class="h.odd ? 'blue' : 'red'"
                >{{ h.tema }}</span>
              </div>
            </div>
            <!-- KK 长龙排行 -->
            <div class="kk-card kk-streak" v-else-if="kkCardOf(i).card === 'streak'">
              <div class="kk-draw-title">第 {{ kkCardOf(i).expect }} 期 · 双面长龙排行</div>
              <div class="kk-streak-empty" v-if="!(kkCardOf(i).rows || []).length">暂无长龙</div>
              <div class="kk-streak-row" v-for="(s, si) in kkCardOf(i).rows" :key="'st' + si">
                <span class="sn">{{ s.name }}</span>
                <div class="bar-wrap"><div class="bar" :style="{ width: Math.min(100, s.count * 12) + '%' }"></div></div>
                <span class="sc">{{ s.count }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="side-fab" v-if="fabPos === 'side'">
        <div
          class="fab-item"
          v-for="item in fabItems"
          :key="item.key"
          :style="{ background: item.color }"
          @click="onFab(item.key)"
        >
          <van-icon :name="item.sideIcon || item.icon || 'apps-o'" size="14" color="#fff" />
          <span>{{ item.sideLabel || item.label }}</span>
          <i class="fab-dot" v-if="item.key === 'order' && selectIds.length"></i>
        </div>
        <div class="fab-item fab-switch" @click="setFabPos('bottom')" title="移到底部">
          <van-icon name="arrow-down" size="14" color="#fff" />
          <span>底部</span>
        </div>
      </div>
      <div class="scroll-bottom" v-show="showScrollBtn" @click="scrollChatBottom(true)">
        <van-icon name="arrow-down" size="18" color="#fff" />
      </div>
    </div>

    <div class="footer kk-footer" v-if="room.lottery.type == 2" :class="{ 'fab-bottom': fabPos === 'bottom' }">
      <div class="bottom-fab" v-if="fabPos === 'bottom'">
        <div class="bfab bfab-ico" @click="setFabPos('side')">
          <van-icon name="pause" size="14" color="#fff" />
        </div>
        <div
          class="bfab"
          v-for="item in fabItems"
          :key="'b' + item.key"
          :class="'bfab-' + (item.tone || 'red')"
          @click="onFab(item.key)"
        >
          <van-icon
            v-if="item.icon"
            :name="item.icon"
            size="12"
            :color="item.tone === 'ghost' ? '#7c5cbf' : '#fff'"
          />
          <em>{{ item.label }}</em>
        </div>
      </div>
      <div class="full-input" v-if="isResting">{{ dailyRest.msg || '每日停盘休息，19:30开盘' }}</div>
      <div class="full-input" v-else-if="opendata.timeout < room.ftime">封盘中禁止投注</div>
      <template v-else>
        <div class="kk-input-row">
          <div class="order-input" @click="openKkPad()">
            <input
              placeholder="输入消息..."
              v-model="keyboard"
              readonly
              @focus="openKkPad()"
            />
          </div>
          <div class="order-btn" @click="sendMsg()">发送</div>
        </div>
        <div class="kk-dock" v-if="fabPos !== 'bottom'">
          <div class="dock-item" :class="{ on: playbox && betMode === 'credit' }" @click="openBetPanel('credit')">
            <van-icon name="credit-pay" size="20" />
            <span>信用</span>
          </div>
          <div class="dock-item" :class="{ on: playbox && betMode === 'table' }" @click="openBetPanel('table')">
            <van-icon name="gem-o" size="20" />
            <span>桌投</span>
          </div>
          <div class="dock-item" :class="{ on: quickShow }" @click="openKkPad()">
            <van-icon name="fire-o" size="20" />
            <span>快投</span>
          </div>
          <div class="dock-item" @click="moreShow = true">
            <van-icon name="add-o" size="20" />
            <span>更多</span>
          </div>
        </div>
      </template>
    </div>

    <div class="footer" v-else-if="room.lottery.type == 1">
      <div class="full-input" v-if="opendata.timeout < room.ftime">封盘中禁止投注</div>
      <div
        class="full-input active-input"
        @click="
          playgroup = 0;
          playbox = true;
        "
        v-else
      >
        下注
      </div>
    </div>

    <van-popup
      v-model:show="playbox"
      position="bottom"
      :style="{ height: 'calc(100% - 165px)' }"
      :overlay-style="{ background: 'none' }"
      z-index="2008"
    >
      <div class="playbox" :class="betMode">
        <div class="header">
          {{ betMode === 'table' ? '桌面投注' : '信用投注' }}
          <van-icon id="closebtn" name="arrow-down" @click="playbox = false" size="20" />
        </div>
        <div class="body">
          <div class="left">
            <div
              :class="playgroup == index ? 'active' : ''"
              v-for="(item, index) in room.playbox"
              :key="'pg-' + index"
              @click="
                selectIds = [];
                selectNumbers = [];
                playgroup = index;
              "
            >
              <div v-if="playgroup == index" class="active-flag"></div>
              {{ item.name }}
            </div>
          </div>
          <div class="right">
            <div class="title">
              {{ room.playbox[playgroup].name }}
              <van-icon name="question-o" @click="openRules()" />
            </div>
            <div class="plays" :class="'cols-' + playCols">
              <div
                class="play-cell"
                v-for="i in room.playbox[playgroup].childrens"
                :key="i.id"
              >
                <div
                  class="btn"
                  :class="selectIds.indexOf(i.id) == -1 ? '' : 'active'"
                  @click="selectId(i.id, room.playbox[playgroup].special)"
                >
                  <span class="play-name">{{ i.playtitle }}</span>
                  <span class="play-odds">{{ i.odds }}</span>
                </div>
              </div>

              <div
                v-if="room.playbox[playgroup].special > 0 && selectIds.length > 0"
                class="special-nums"
              >
                <div class="number" v-for="k in 49" :key="'n-' + k">
                  <div class="btn" :class="selectNumbers.indexOf(k) == -1 ? '' : 'active'" @click="selectNumber(k)">
                    {{ k }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="f1">
            共{{ selectIds.length }}单, 合计{{ parseFloat(selectIds.length * total) }}元
          </div>
          <div class="f2">
            <div class="trash" @click="selectIds = [];selectNumbers = []">
              <van-icon name="delete" size=".5rem" color="#cccccc" />
            </div>
            <div class="quick">
              <div @click="total = 10">10</div>
              <div @click="total = 20">20</div>
              <div @click="total = 50">50</div>
              <div @click="total = 200">200</div>
              <div @click="total = 500">500</div>
            </div>
            <div class="input">
              <input v-model="total" type="number" />
            </div>
          </div>
          <div class="f3">
            <div class="lastorder" @click="loadRecent()">最近投注</div>
            <div class="submitorder" @click="previewOrder()">立即投注</div>
          </div>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model:show="quickShow"
      position="bottom"
      :style="{ height: '58%' }"
      :overlay-style="{ background: 'rgba(0,0,0,.25)' }"
      z-index="2012"
      round
    >
      <div class="kk-pad">
        <div class="kk-pad-head">
          <span>快捷下注</span>
          <van-icon name="arrow-down" @click="quickShow = false" />
        </div>
        <div class="kk-pad-input-row">
          <input
            class="kk-pad-input"
            type="text"
            v-model="keyboard"
            placeholder="点选玩法与金额，如 大100"
            @keyup.enter="sendFromPad()"
          />
          <div class="kk-pad-send" @click="sendFromPad()">发送</div>
        </div>
        <div class="kk-tema-row">
          <div
            class="tema-chip"
            v-for="n in 28"
            :key="'t' + (n - 1)"
            @click="appendQuick(String(n - 1) + '点')"
          >
            <b>{{ n - 1 }}</b>
            <em>{{ oddOf(String(n - 1)) }}</em>
          </div>
        </div>
        <div class="kk-grid">
          <div class="kk-cell ghost" @click="keyboard = ''">取消下注</div>
          <div class="kk-cell play" @click="appendQuick('豹子')">
            <b>豹子</b><em>1:{{ oddOf('豹子') }}</em>
          </div>
          <div class="kk-cell play" @click="appendQuick('顺子')">
            <b>顺子</b><em>1:{{ oddOf('顺子') }}</em>
          </div>
          <div class="kk-cell play" @click="appendQuick('对子')">
            <b>对子</b><em>1:{{ oddOf('对子') }}</em>
          </div>
          <div class="kk-cell dark" @click="backspaceQuick()">
            <van-icon name="revoke" size="20" />
          </div>

          <div class="kk-cell play" @click="appendQuick('大')">
            <b>大</b><em>1:{{ oddOf('大') }}</em>
          </div>
          <div class="kk-cell num" @click="appendQuick('1')">1</div>
          <div class="kk-cell num" @click="appendQuick('2')">2</div>
          <div class="kk-cell num" @click="appendQuick('3')">3</div>
          <div class="kk-cell play" @click="appendQuick('大单')">
            <b>大单</b><em>1:{{ oddOf('大单') }}</em>
          </div>

          <div class="kk-cell play" @click="appendQuick('小')">
            <b>小</b><em>1:{{ oddOf('小') }}</em>
          </div>
          <div class="kk-cell num" @click="appendQuick('4')">4</div>
          <div class="kk-cell num" @click="appendQuick('5')">5</div>
          <div class="kk-cell num" @click="appendQuick('6')">6</div>
          <div class="kk-cell play" @click="appendQuick('大双')">
            <b>大双</b><em>1:{{ oddOf('大双') }}</em>
          </div>

          <div class="kk-cell play" @click="appendQuick('单')">
            <b>单</b><em>1:{{ oddOf('单') }}</em>
          </div>
          <div class="kk-cell num" @click="appendQuick('7')">7</div>
          <div class="kk-cell num" @click="appendQuick('8')">8</div>
          <div class="kk-cell num" @click="appendQuick('9')">9</div>
          <div class="kk-cell play" @click="appendQuick('小单')">
            <b>小单</b><em>1:{{ oddOf('小单') }}</em>
          </div>

          <div class="kk-cell play" @click="appendQuick('双')">
            <b>双</b><em>1:{{ oddOf('双') }}</em>
          </div>
          <div class="kk-cell play" @click="appendQuick('极大')">
            <b>极大</b><em>1:{{ oddOf('极大') }}</em>
          </div>
          <div class="kk-cell num" @click="appendQuick('0')">0</div>
          <div class="kk-cell play" @click="appendQuick('极小')">
            <b>极小</b><em>1:{{ oddOf('极小') }}</em>
          </div>
          <div class="kk-cell play" @click="appendQuick('小双')">
            <b>小双</b><em>1:{{ oddOf('小双') }}</em>
          </div>

          <div class="kk-cell play" @click="appendQuick('龙')">
            <b>龙</b><em>1:{{ oddOf('龙') }}</em>
          </div>
          <div class="kk-cell play" @click="appendQuick('虎')">
            <b>虎</b><em>1:{{ oddOf('虎') }}</em>
          </div>
          <div class="kk-cell play" @click="appendQuick('合')">
            <b>合</b><em>1:{{ oddOf('合') }}</em>
          </div>
          <div class="kk-cell amt" @click="appendQuick('100')">100</div>
          <div class="kk-cell confirm" @click="submitQuick()">确认下注</div>
        </div>
      </div>
    </van-popup>

    <van-popup v-model:show="moreShow" position="bottom" round z-index="2012">
      <div class="more-box">
        <div class="more-title">更多</div>
        <div class="more-item" @click="moreShow = false; openBetPanel('credit')">信用投注</div>
        <div class="more-item" @click="moreShow = false; openBetPanel('table')">桌面投注</div>
        <div class="more-item" @click="openBetSlip()">注单查询</div>
        <div class="more-item" @click="moreShow = false; openlist = true">开奖历史</div>
        <div class="more-item" @click="moreShow = false; openRules()">玩法说明</div>
        <div class="more-item" @click="setFabPos('side')">快捷栏：右侧{{ fabPos === 'side' ? ' ✓' : '' }}</div>
        <div class="more-item" @click="setFabPos('bottom')">快捷栏：输入框上方{{ fabPos === 'bottom' ? ' ✓' : '' }}</div>
        <div class="more-item cancel" @click="moreShow = false">取消</div>
      </div>
    </van-popup>

    <van-popup v-model:show="showHelp" round position="center" :style="{ width: '88%', maxHeight: '78%' }" z-index="2200" class="kk-rules-popup">
      <div class="kk-rules">
        <div class="kk-rules-hd">
          <span>游戏规则</span>
          <van-icon name="cross" @click="showHelp = false" />
        </div>
        <div class="kk-rules-bd" v-html="kkRulesHtml"></div>
      </div>
    </van-popup>

    <van-dialog
      v-model:show="showPreview"
      title="投注确认"
      confirm-button-color="#158bf4"
      :show-cancel-button="true"
      :close-on-click-overlay="true"
      @confirm="createOrder()"
    >
      <div class="preview" v-for="(i, index) in order">
        <div class="p1">{{ i[0] }}</div>
        <div class="p2">{{ i[1].playtitle }}</div>
        <div class="p3">
          <input v-model="i[2]" />
          <van-icon class="remove" name="minus" @click="removePreview(index)" />
        </div>
      </div>
      <div style="padding: 0 10px">共{{ order.length }}单, 合计{{ getAmount() }}元</div>
    </van-dialog>

    <van-popup v-model:show="recentShow" position="bottom" :style="{ height: '72%' }" z-index="2010" round>
      <div class="betslip">
        <div class="betslip-head">
          <span>注单</span>
          <van-icon name="cross" @click="recentShow = false" />
        </div>
        <div class="betslip-user">
          <div class="bu-left">
            <div class="bu-name">{{ betSlipUser.username || ($store.state.userInfo && $store.state.userInfo.username) || '-' }}</div>
            <div class="bu-sub">ID {{ betSlipUser.id || ($store.state.userInfo && $store.state.userInfo.id) || '-' }} · 余额 {{ fmtMoney(betSlipUser.balance != null ? betSlipUser.balance : displayBalance) }}</div>
          </div>
          <div class="bu-btn" @click="loadBetSlip(betSlipRange, 1)">刷新</div>
        </div>

        <div class="betslip-section">
          <div class="sec-title">未结算竞猜 <em>({{ pendingList.length }}条)</em></div>
          <div class="bet-table head">
            <span>期号</span><span>内容</span><span>时间</span><span>状态</span>
          </div>
          <div v-if="pendingList.length == 0" class="betslip-empty">暂无未结算竞猜</div>
          <div class="bet-table row" v-for="item in pendingList" :key="'p' + item.bet_no">
            <span>{{ item.expect }}</span>
            <span>{{ item.content || (item.playtitle + item.amount) }}</span>
            <span>{{ item.time_short || item.time }}</span>
            <span class="pending">未结算</span>
          </div>
        </div>

        <div class="betslip-section grow">
          <div class="sec-title tabs">
            <span>记录</span>
            <div class="tab-row">
              <em :class="{ on: betSlipRange === 'today' }" @click="loadBetSlip('today', 1)">今日</em>
              <em :class="{ on: betSlipRange === 'yesterday' }" @click="loadBetSlip('yesterday', 1)">昨日</em>
              <em :class="{ on: betSlipRange === 'history' }" @click="loadBetSlip('history', 1)">历史</em>
              <em :class="{ on: betSlipRange === 'month30' }" @click="loadBetSlip('month30', 1)">30日统计</em>
            </div>
          </div>

          <div v-if="betSlipRange === 'month30'" class="month-stats">
            <div class="ms-row"><label>注单数</label><b>{{ monthStats.count || 0 }}</b></div>
            <div class="ms-row"><label>已结算</label><b>{{ monthStats.settled || 0 }}</b></div>
            <div class="ms-row"><label>未结算</label><b>{{ monthStats.pending || 0 }}</b></div>
            <div class="ms-row"><label>投注额</label><b>{{ fmtMoney(monthStats.bet_amount) }}</b></div>
            <div class="ms-row"><label>派彩</label><b>{{ fmtMoney(monthStats.win_amount) }}</b></div>
            <div class="ms-row"><label>输赢</label><b :class="(monthStats.profit||0) >= 0 ? 'win' : 'lose'">{{ fmtMoney(monthStats.profit) }}</b></div>
          </div>

          <template v-else>
            <div class="bet-table head">
              <span>期号</span><span>内容</span><span>时间</span><span>结果</span>
            </div>
            <div v-if="recentList.length == 0" class="betslip-empty">暂无记录</div>
            <div class="bet-table row" v-for="item in recentList" :key="item.bet_no">
              <span>{{ item.expect }}</span>
              <span>{{ item.content || (item.playtitle + item.amount) }}</span>
              <span>{{ item.time_short || item.time }}</span>
              <span v-if="item.status == 0" class="pending">未结算</span>
              <span v-else-if="item.win > 0" class="win">中{{ fmtMoney(item.win) }}</span>
              <span v-else class="lose">-{{ fmtMoney(item.amount) }}</span>
            </div>
            <div class="bet-pager">
              <div class="pg-btn" :class="{ off: betSlipPage <= 1 }" @click="betSlipPage > 1 && loadBetSlip(betSlipRange, betSlipPage - 1)">上一页</div>
              <div class="pg-num">{{ betSlipPage }} / {{ betSlipPages }}</div>
              <div class="pg-btn" :class="{ off: betSlipPage >= betSlipPages }" @click="betSlipPage < betSlipPages && loadBetSlip(betSlipRange, betSlipPage + 1)">下一页</div>
            </div>
          </template>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-if="room && room.lottery && room.lottery.type == 1"
      v-model:show="openlist"
      position="top"
      :style="{ height: histPopupH, marginTop: histPopupTop }"
      :overlay-style="{ background: 'none' }"
      z-index="2000"
    >
      <div class="l6hlist">
        <div class="row">
          <div>期号</div>
          <div>时间</div>
          <div class="opencode">开奖结果</div>
        </div>
        <div class="row" v-for="item in room.lottery.openlist" :key="'6h' + item.expect">
          <div>{{ item.expect }}</div>
          <div>{{ item.opentime2 }}</div>
          <div class="opencode">
            <div><div class="ball" :class="item.extend[0][1]">{{ item.extend[0][0] }}</div></div>
            <div><div class="ball" :class="item.extend[1][1]">{{ item.extend[1][0] }}</div></div>
            <div><div class="ball" :class="item.extend[2][1]">{{ item.extend[2][0] }}</div></div>
            <div><div class="ball" :class="item.extend[3][1]">{{ item.extend[3][0] }}</div></div>
            <div><div class="ball" :class="item.extend[4][1]">{{ item.extend[4][0] }}</div></div>
            <div><div class="ball" :class="item.extend[5][1]">{{ item.extend[5][0] }}</div></div>
            <div style="width: 10px">+</div>
            <div><div class="ball" :class="item.extend[6][1]">{{ item.extend[6][0] }}</div></div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { showDialog } from "vant";
export default {
  name: "lotteryPage",
  data() {
    return {
      room_id: null,
      room: null,
      order: [],
      opendata: null,
      panelShow: true,
      timer: false,
      keyboard: null,
      playbox: false,
      betMode: "credit",
      openlist: false,
      histLimit: 50,
      histLimits: [30, 50, 100],
      infoShow: false,
      userStats: { balance: 0, flow: 0, today_win: 0, rebate: 0 },
      total: 10,
      playgroup: 0,
      selectIds: [],
      selectNumbers: [],
      showHelp: false,
      help_allow_html: true,
      showPreview: false,
      recentShow: false,
      recentList: [],
      pendingList: [],
      betSlipRange: "today",
      betSlipPage: 1,
      betSlipPages: 1,
      betSlipUser: {},
      monthStats: {},
      quickShow: false,
      moreShow: false,
      quickPlays: ["大", "小", "单", "双", "大单", "大双", "小单", "小双", "极大", "极小", "豹子", "对子", "顺子", "龙", "虎", "合", "边", "中", "尾大", "尾小", "13点", "14点"],
      quickAmts: [10, 20, 50, 100, 200, 500],
      chatdata: [],
      playdata: [],
      wss: null,
      pollTimer: null,
      lastMsgId: 0,
      seenMsg: {},
      showScrollBtn: false,
      stickBottom: true,
      fabPos: localStorage.getItem("lottery_fab_pos") || "bottom",
      dailyRest: { active: false, start: "18:57", end: "19:34", open_at: "19:30", msg: "每日停盘休息，19:30开盘" },
      welcomePushed: false,
      kkBotName: "KK GAME",
      kkBotAvatar: "/static/img/lottery/system.svg",
      fabItems: [
        { key: "recharge", label: "上分", sideLabel: "上分", icon: "", sideIcon: "gold-coin-o", tone: "red", color: "#f25b6a" },
        { key: "withdraw", label: "下分", sideLabel: "下分", icon: "", sideIcon: "balance-pay", tone: "red", color: "#f25b6a" },
        { key: "bets", label: "注单", sideLabel: "注单", icon: "", sideIcon: "orders-o", tone: "red", color: "#f25b6a" },
        { key: "rules", label: "规则", sideLabel: "规则", icon: "", sideIcon: "notes-o", tone: "pink", color: "#e879a9" },
        { key: "order", label: "快捷下注", sideLabel: "快投", icon: "fire", sideIcon: "fire", tone: "grad", color: "#6d7cff" },
        { key: "peek", label: "咪牌", sideLabel: "咪牌", icon: "eye-o", sideIcon: "eye-o", tone: "ghost", color: "#8b5cf6" },
        { key: "openweb", label: "开奖网", sideLabel: "开奖", icon: "cluster-o", sideIcon: "cluster-o", tone: "ghost", color: "#3b82f6" },
        { key: "rebate", label: "回水", sideLabel: "回水", icon: "cash-back-record", sideIcon: "cash-back-record", tone: "ghost", color: "#eab308" },
        { key: "more", label: "更多", sideLabel: "更多", icon: "add-o", sideIcon: "add-o", tone: "ghost", color: "#64748b" },
      ],
    };
  },
  computed: {
    kkRulesHtml: function () {
      var key = (this.room && this.room.odds_key) ? String(this.room.odds_key) : "20";
      var name = (this.room && this.room.lottery && this.room.lottery.title) || "加拿大28";
      var head = "";
      if (key === "217") {
        head = [
          "<p>🏆 满赔率-2.17</p>",
          "<p>👑全场任意玩法限额（5-60000）</p>",
          "<p>✅赔率：大小/单双 2.17倍</p>",
          "<p>小单/大双 4.72倍　大单/小双 4.32倍</p>",
          "<p>⚠️遇13/14大小单双、组合回本金！</p>",
        ].join("");
      } else if (key === "28") {
        head = [
          "<p>🏆 满赔率-2.84</p>",
          "<p>👑全场任意玩法限额（5-60000）</p>",
          "<p>✅赔率：大小/单双 2.84倍</p>",
          "<p>小单/大双 6.77倍　大单/小双 6.31倍</p>",
          "<p>⚠️遇13/14、对子、顺子、豹子中奖回本金！</p>",
          "<p>（注：开出890/190等三个数字均为顺子）</p>",
        ].join("");
      } else {
        head = [
          "<p>🏆 满赔率-2.0</p>",
          "<p>👑全场任意玩法限额（5-60000）</p>",
          "<p>✅赔率：大小/单双 2倍，开13/14也赔2倍</p>",
          "<p>小单/大双 4.2倍　大单/小双 4.2倍</p>",
          "<p>⚠️组合遇13/14回本金！</p>",
        ].join("");
      }
      return [
        "<p>下注格式为：单1000 大单2000</p>",
        "<p>押单数格式为：数字+押+金额：例27.100 或者 27T100</p>",
        "<hr/>",
        head,
        "<p>✅其他赔率：</p>",
        "<p>对子 3.5倍　顺子 17倍　豹子 98倍　极值 17倍</p>",
        "<p>虎/龙 2倍　合 9.97倍　边 2.25倍　大边/小边 4.4倍　中 1.7倍</p>",
        "<p>✅abc玩法</p>",
        "<p>大小单双 1.99倍　小单/大双 4.95倍　大单/小双 3.32倍　数字 9.98倍</p>",
        "<p>✅数字赔率 (0-27)</p>",
        "<p>0/27=888　1/26=258　2/25=108　3/24=68</p>",
        "<p>4/23=48　5/22=38　6/21=28　7/20=24</p>",
        "<p>8/19=20　9/18=17　10/17=15　11/16=14</p>",
        "<p>12/15=13　13/14=13.3</p>",
        "<hr/>",
        "<p><b>1️⃣【abc玩法】</b>猜" + name + "的abc三个位置</p>",
        "<p>例：2(A)+6(B)+7(C)=15　第一球A　第二球B　第三球C</p>",
        "<p>下注：A大100 B单100　a小单100　a6.100</p>",
        "<p><b>2️⃣【三军】</b>三军8.100　一中3.3 / 二中6.6 / 三中15</p>",
        "<p><b>3️⃣龙虎合</b> a&gt;c龙 a&lt;c虎 a=c合；开合杀龙虎本金</p>",
        "<p><b>4️⃣中边</b> 0-9小边　18-27大边　10-17中</p>",
        "<p><b>5️⃣尾数</b> 尾大/小/单/双2.4　尾组合4.8　尾特8；0/9通杀</p>",
      ].join("");
    },
    playCols: function () {
      if (!this.room || !this.room.playbox || !this.room.playbox[this.playgroup]) return 2;
      var n = (this.room.playbox[this.playgroup].childrens || []).length;
      if (this.betMode === "table") return n <= 4 ? 2 : 3;
      if (n <= 4) return 2;
      if (n <= 9) return 3;
      return 4;
    },
    displayBalance: function () {
      if (this.userStats && this.userStats.balance != null) {
        return this.fmtMoney(this.userStats.balance);
      }
      return this.$store.state.userInfo.balance;
    },
    histPopupTop: function () {
      var top = 173;
      if (this.infoShow) top += 52;
      return top + "px";
    },
    histPopupH: function () {
      return "min(58vh, 420px)";
    },
    histList: function () {
      var list = (this.room && this.room.lottery && this.room.lottery.openlist) || [];
      return list.slice(0, this.histLimit || 50);
    },
    oddsMap: function () {
      var map = {};
      if (!this.room || !this.room.playbox) return map;
      this.room.playbox.forEach(function (g) {
        (g.childrens || []).forEach(function (c) {
          map[String(c.playtitle)] = c.odds;
        });
      });
      return map;
    },
    isResting: function () {
      if (this.dailyRest && this.dailyRest.active) return true;
      if (this.opendata && this.opendata.daily_rest) return true;
      return this.localDailyRestActive();
    },
    restOpenLabel: function () {
      var t = (this.dailyRest && (this.dailyRest.open_at || this.dailyRest.end)) || "19:30";
      return String(t).replace(/开盘$/, "") + "开盘";
    },
  },
  watch: {
    "$route.query.room_id": function () {
      this.openRoom();
    },
  },
  created() {
    this.openRoom();
  },

  methods: {
    localDailyRestActive: function () {
      try {
        var parts = new Intl.DateTimeFormat("en-GB", {
          timeZone: "Asia/Shanghai",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }).formatToParts(new Date());
        var h = 0, m = 0, i;
        for (i = 0; i < parts.length; i++) {
          if (parts[i].type === "hour") h = parseInt(parts[i].value, 10) || 0;
          if (parts[i].type === "minute") m = parseInt(parts[i].value, 10) || 0;
        }
        var hm = h * 60 + m;
        var start = 18 * 60 + 57;
        var end = 19 * 60 + 34;
        return hm >= start && hm < end;
      } catch (e) {
        return false;
      }
    },
    openBetPanel: function (mode) {
      if (this.isResting) {
        this.$parent.showTost(0, this.dailyRest.msg || "每日停盘休息，19:30开盘");
        return;
      }
      this.quickShow = false;
      this.betMode = mode || "table";
      this.playgroup = 0;
      this.selectIds = [];
      this.selectNumbers = [];
      this.playbox = true;
    },

    openKkPad: function () {
      if (this.isResting) {
        this.$parent.showTost(0, this.dailyRest.msg || "每日停盘休息，19:30开盘");
        return;
      }
      this.playbox = false;
      this.quickShow = true;
    },

    openKefu: function () {
      if (this.$parent && this.$parent.openKefu) {
        this.$parent.openKefu();
      } else {
        this.$router.push("/kefu");
      }
    },

    setFabPos: function (pos) {
      this.fabPos = pos === "bottom" ? "bottom" : "side";
      localStorage.setItem("lottery_fab_pos", this.fabPos);
      this.moreShow = false;
      this.$parent.showTost(1, this.fabPos === "side" ? "快捷栏已放右侧" : "快捷栏已放输入框上方");
    },

    goPage: function (path) {
      if (this.$parent && this.$parent.goNav) {
        this.$parent.goNav(path);
      } else {
        this.$router.push(path);
      }
    },

    onFab: function (key) {
      if (key === "more") {
        this.moreShow = true;
        return;
      }
      if (key === "openweb") {
        this.openlist = true;
        return;
      }
      if (key === "order") {
        this.openKkPad();
        return;
      }
      if (key === "recharge") {
        this.goPage("/recharge");
        return;
      }
      if (key === "withdraw") {
        this.goPage("/withdrawal");
        return;
      }
      if (key === "bets") {
        this.openBetSlip();
        return;
      }
      if (key === "rules") {
        this.openRules();
        return;
      }
      if (key === "peek") {
        this.panelShow = !this.panelShow;
        this.$parent.showTost(1, this.panelShow ? "已显示开奖信息" : "已隐藏开奖信息");
        return;
      }
      if (key === "rebate") {
        this.infoShow = true;
        this.getLottery();
        this.$parent.showTost(1, "回水：" + this.fmtMoney(this.userStats.rebate));
      }
    },

    isSysMsg: function (row) {
      if (!row) return false;
      if (row.welcome) return true;
      if (row.author === "KK") return true;
      var c = String(row.content || "");
      // 上下分由模拟会员气泡展示（带头像），不当系统消息
      return (
        c.indexOf("KKCARD:") === 0 ||
        c.indexOf("已经封盘") >= 0 ||
        c.indexOf("下注核对") >= 0 ||
        c.indexOf("历史开奖") >= 0 ||
        c.indexOf("欢迎您") >= 0 ||
        c.indexOf("欢迎进入KK国际") >= 0 ||
        c.indexOf("停盘休息") >= 0 ||
        c.indexOf("现在可以下注") >= 0
      );
    },

    kkCardOf: function (row) {
      if (!row || !row.content) return null;
      var c = String(row.content);
      if (c.indexOf("KKCARD:") !== 0) return null;
      try {
        return JSON.parse(c.slice(7));
      } catch (e) {
        return null;
      }
    },

    isWelcomeMsg: function (row) {
      if (!row) return false;
      if (row.welcome) return true;
      var c = String(row.content || "");
      return c.indexOf("欢迎进入KK国际") >= 0;
    },

    welcomeText: function (row) {
      var c = String((row && row.content) || "欢迎进入KK国际!");
      return c.replace(/^📢\s*/, "").trim() || "欢迎进入KK国际!";
    },

    displayAuthor: function (row) {
      if (!row) return "";
      if (row.author === "KK") return this.kkBotName || "KK GAME";
      return row.author || "";
    },
    displayAvatar: function (row) {
      var fallback = this.kkBotAvatar || "/static/img/lottery/system.svg";
      if (!row) return fallback;
      if (row.author === "KK") {
        var a = row.avatar || "";
        if (!a || a.indexOf("system.svg") >= 0) return fallback;
        return a;
      }
      return row.avatar || "/static/img/lottery/system.svg";
    },
    pushWelcomeOnce: function (text) {
      if (this.welcomePushed) return;
      this.welcomePushed = true;
      this.chatdata.push({
        left: 1,
        author: "KK",
        avatar: this.kkBotAvatar || "/static/img/lottery/system.svg",
        content: text || "欢迎进入KK国际!",
        welcome: true,
      });
    },

    shortExpect: function (e) {
      var s = String(e || "");
      return s.length > 6 ? s.slice(-6) : s;
    },

    comboTagClass: function (combo) {
      if (!combo) return "blue";
      if (combo.indexOf("大") === 0) return "red";
      return "blue";
    },

    tagClass: function (t) {
      var s = String(t || "");
      if (s === "大" || s === "双" || s === "龙" || s === "庄" || s === "大边" || s === "大单" || s === "大双" || s === "红波") return "red";
      if (s === "合") return "purple";
      if (s === "绿波") return "green";
      if (s.indexOf("波") >= 0) return "gray";
      return "blue";
    },

    openRules: function () {
      this.showHelp = true;
    },

    onChatScroll: function () {
      var box = document.getElementById("chatbox");
      if (!box) return;
      var dist = box.scrollHeight - box.scrollTop - box.clientHeight;
      this.stickBottom = dist < 40;
      this.showScrollBtn = dist > 80;
    },

    scrollChatBottom: function (force) {
      var box = document.getElementById("chatbox");
      if (!box) return;
      box.scrollTop = box.scrollHeight;
      this.stickBottom = true;
      this.showScrollBtn = false;
      if (force) {
        this.$nextTick(function () {
          box.scrollTop = box.scrollHeight;
        });
      }
    },

    oddOf: function (title) {
      var v = this.oddsMap[title];
      if (v == null || v === "") return "--";
      return v;
    },

    // 大小单双标签：单蓝、双红
    temaColor: function (n) {
      var v = parseInt(n, 10);
      if (isNaN(v)) return "blue";
      return v % 2 === 1 ? "blue" : "red";
    },
    // 大小标签：大红、小蓝
    sizeColor: function (n) {
      var v = parseInt(n, 10);
      if (isNaN(v)) return "blue";
      return v >= 14 ? "red" : "blue";
    },
    // 特码热/冷（大红/小蓝）— 历史结果和值底色
    temaHotCool: function (n) {
      var v = parseInt(n, 10);
      if (isNaN(v)) return "cool";
      return v >= 14 ? "hot" : "cool";
    },
    temaSize: function (n) {
      var v = parseInt(n, 10);
      if (isNaN(v)) return "";
      return v >= 14 ? "大" : "小";
    },
    temaOddEven: function (n) {
      var v = parseInt(n, 10);
      if (isNaN(v)) return "";
      return v % 2 === 1 ? "单" : "双";
    },
    pad2: function (n) {
      var v = parseInt(n, 10);
      if (isNaN(v)) return "00";
      return v < 10 ? "0" + v : String(v);
    },
    histN: function (item, idx) {
      if (!item) return 0;
      if (item.extend && item.extend[0] && item.extend[0][idx] != null) return item.extend[0][idx];
      if (idx === 0) return item.n1 != null ? item.n1 : 0;
      if (idx === 1) return item.n2 != null ? item.n2 : 0;
      return item.n3 != null ? item.n3 : 0;
    },
    histTema: function (item) {
      if (!item) return 0;
      if (item.tema != null) return item.tema;
      if (item.extend && item.extend[1] != null) return item.extend[1];
      return 0;
    },
    // 与结算一致：极大 >=22，极小 <=5
    histExtreme: function (item) {
      if (item && item.extreme) return item.extreme;
      var t = parseInt(this.histTema(item), 10);
      if (t >= 22) return "极大";
      if (t <= 5) return "极小";
      return "无";
    },
    histPattern: function (item) {
      // KK：无「半顺」，半顺一律显示杂六
      if (item && item.pattern) {
        return item.pattern === "半顺" ? "杂六" : item.pattern;
      }
      var a = [this.histN(item, 0), this.histN(item, 1), this.histN(item, 2)].sort(function (x, y) {
        return x - y;
      });
      if (a[0] === a[1] && a[1] === a[2]) return "豹子";
      if (a[2] - a[1] === 1 && a[1] - a[0] === 1) return "顺子";
      if (a[0] === a[1] || a[1] === a[2]) return "对子";
      return "杂六";
    },
    histTail: function (item) {
      if (item && item.tail != null) return item.tail;
      return this.histTema(item) % 10;
    },
    extremeColor: function (label) {
      if (label === "极大" || label === "极小") return "#f39c12";
      return "#aaaaaa";
    },
    shapeColor: function (label) {
      if (label === "杂六") return "#27ae60";
      return "#f39c12";
    },
    // KK波色：开奖数字球红/蓝/绿
    ballWave: function (n) {
      var v = parseInt(n, 10);
      if (isNaN(v)) return "blue";
      var red = [1, 2, 7, 8, 12, 13, 18, 19, 23, 24];
      var blue = [3, 4, 9, 10, 14, 15, 20, 25, 26];
      if (red.indexOf(v) >= 0) return "red";
      if (blue.indexOf(v) >= 0) return "blue";
      return "green";
    },

    toggleInfo: function () {
      this.infoShow = !this.infoShow;
      if (this.infoShow) {
        this.getLottery();
      }
    },

    toggleHistory: function () {
      this.openlist = !this.openlist;
    },

    fmtMoney: function (v) {
      var n = parseFloat(v);
      if (isNaN(n)) n = 0;
      return n.toFixed(2);
    },

    appendQuick: function (text) {
      var cur = this.keyboard || "";
      var t = String(text);
      if (t === " ") {
        if (cur && !/\s$/.test(cur)) this.keyboard = cur + " ";
        return;
      }
      // 纯数字：接到当前段金额后
      if (/^\d+$/.test(t)) {
        var trimmed = cur.replace(/\s+$/, "");
        if (!trimmed) {
          this.keyboard = t;
          return;
        }
        if (/\d+$/.test(trimmed)) {
          this.keyboard = trimmed.replace(/\d+$/, function (m) {
            return m + t;
          });
        } else {
          this.keyboard = trimmed + t;
        }
        return;
      }
      // 玩法 / N点：新开一段
      var base = cur.replace(/\s+$/, "");
      this.keyboard = base ? base + " " + t : t;
    },

    backspaceQuick: function () {
      var cur = this.keyboard || "";
      if (!cur) return;
      this.keyboard = cur.slice(0, -1);
    },

    submitQuick: function () {
      var text = (this.keyboard || "").trim();
      if (!text) {
        this.$parent.showTost(0, "请先选择玩法与金额");
        return;
      }
      this.sendMsg(true);
    },
    sendFromPad: function () {
      var text = (this.keyboard || "").trim();
      if (!text) {
        this.$parent.showTost(0, "请输入内容");
        return;
      }
      this.sendMsg(false);
    },
    openRoom: function () {
    var _that = this;
    if (_that.pollTimer) {
      clearInterval(_that.pollTimer);
      _that.pollTimer = null;
    }
    if (_that.timer) {
      clearInterval(_that.timer);
      _that.timer = null;
    }
    var query = _that.$route.query;
    _that.room_id = query.room_id;
    _that.room = null;
    _that.chatdata = [];
    _that.seenMsg = {};
    _that.lastMsgId = 0;
    _that.welcomePushed = false;
    _that.dailyRest = { active: false, start: "18:57", end: "19:34", open_at: "19:30", msg: "每日停盘休息，19:30开盘" };

    let token = localStorage.getItem("token") || sessionStorage.getItem("token") || "";

    if (!token) {
      setTimeout(() => {
        _that.$parent.showTost(0, "请登录！");
        _that.$parent.goNav(`/`);
      }, 1000);
      return;
    }

    _that.getLottery();
    _that.startTimer();
    },

    // 获取房间信息
    getLottery: function () {
      var _that = this;
      if (_that.room == null) {
        _that.$parent.showLoading();
      }
      _that.$apiFun
        .get("/api/lotteryRoom?room_id=" + _that.room_id)
        .then((res) => {
          if (!res || res.code != 200 || !res.data) {
            _that.$parent.hideLoading();
            return;
          }
          _that.room = res.data;
          _that.opendata = (res.data.lottery && res.data.lottery.nowdata) || _that.opendata;
          if (res.data.kk_bot) {
            if (res.data.kk_bot.name) _that.kkBotName = res.data.kk_bot.name;
            if (res.data.kk_bot.avatar) _that.kkBotAvatar = res.data.kk_bot.avatar;
          }
          if (res.data.daily_rest) {
            _that.dailyRest = Object.assign({}, _that.dailyRest, res.data.daily_rest);
          }
          if (res.data.user_stats) {
            _that.userStats = res.data.user_stats;
            if (res.data.user_stats.balance != null) {
              try {
                var info = JSON.parse(localStorage.getItem("userInfo") || "{}");
                info.balance = res.data.user_stats.balance;
                localStorage.setItem("userInfo", JSON.stringify(info));
                _that.$store.commit("changUserInfo");
              } catch (e) {}
            }
          }
          if (_that.chatdata.length < 1) {
            var list = res.data.chatdata || [];
            var hasWelcome = false;
            for (let i = 0; i < list.length; i++) {
              let tmp = list[i];
              var isWelcome = !!(tmp.welcome || String(tmp.content || "").indexOf("欢迎进入KK国际") >= 0);
              if (isWelcome) hasWelcome = true;
              _that.chatdata.push({
                left: _that.isMineUser(tmp.user_id) ? 0 : 1,
                author: tmp.author,
                avatar: tmp.headurl || "/static/img/lottery/system.svg",
                content: tmp.content,
                welcome: isWelcome,
                user_id: tmp.user_id,
              });
              if (tmp.id) {
                _that.seenMsg[tmp.id] = 1;
                _that.lastMsgId = tmp.id;
              }
            }
            if (!hasWelcome) {
              _that.pushWelcomeOnce(res.data.welcome || "欢迎进入KK国际!");
            } else {
              _that.welcomePushed = true;
            }

            setTimeout(() => {
              _that.startPoll();
              let chatbox = document.getElementById("chatbox");
              if (chatbox) chatbox.scrollTop = chatbox.scrollHeight;
            }, 500);
          }
          _that.$parent.hideLoading();
        })
        .catch((res) => {
          _that.$parent.hideLoading();
        });
    },

    // 获取房间消息
    getRoomMessage: function () {

    },

    startPoll: function () {
      var _that = this;
      if (_that.pollTimer) {
        clearInterval(_that.pollTimer);
      }
      _that.pollTimer = setInterval(() => {
        _that.$apiFun.get("/api/lotteryMessage?room_id=" + _that.room_id + "&since=" + (_that.lastMsgId || 0)).then((res) => {
          if (res.code != 200 || !res.data) return;
          res.data.forEach((row) => {
            _that.lastMsgId = row.id;
            if (_that.seenMsg[row.id]) return;
            _that.seenMsg[row.id] = 1;
            _that.msgReceive(row.user_id, row.author, row.avatar || "/static/img/lottery/system.svg", row.content);
            var c = String(row.content || "");
            if (
              row.user_id == 0 &&
              (c.indexOf("未中") >= 0 ||
                c.indexOf(" 中 ") >= 0 ||
                c.indexOf("历史开奖") >= 0 ||
                c.indexOf("现在可以下注") >= 0)
            ) {
              _that.getLottery();
              _that.$apiFun.post("/api/refreshusermoney", {}).then(function (money) {
                if (money.code == 200 && money.data) {
                  localStorage.setItem("userInfo", JSON.stringify(money.data));
                  _that.$store.commit("changUserInfo");
                }
              });
            }
          });
        });
      }, 3000);
    },

    selectId: function (id, special = 0) {
      if (special == 1) {
        this.selectIds = [];
        this.selectNumbers = [];
      }

      let index = this.selectIds.indexOf(id);
      if (index == -1) {
        this.selectIds.push(id);
      } else {
        this.selectIds.splice(index, 1);
      }
    },

    selectNumber: function (k) {
      let index = this.selectNumbers.indexOf(k);
      if (index == -1) {
        this.selectNumbers.push(k);
      } else {
        this.selectNumbers.splice(index, 1);
      }
    },

    startTimer: function () {
      var _that = this;
      _that.timer = setInterval(() => {
        var resting = _that.localDailyRestActive();
        if (_that.dailyRest && _that.dailyRest.active !== resting) {
          _that.$set(_that.dailyRest, "active", resting);
        }
        _that.opendata && _that.opendata.timeout--;
        if (_that.opendata && _that.opendata.timeout < _that.room.ftime) {
          _that.playbox = false;
        }

        if (_that.opendata && _that.opendata.timeout < 0) {
          _that.getLottery();
        }
      }, 1000);
    },

    previewOrder: function () {
      this.order = [];

      for (let i = 0; i < this.room.playbox[this.playgroup].childrens.length; i++) {
        let tmp = this.room.playbox[this.playgroup].childrens[i];
        if (this.selectIds.indexOf(tmp.id) != -1) {
          this.order.push({
            0: this.room.playbox[this.playgroup].name,
            1: tmp,
            2: this.total,
          });
        }
      }

      if (this.order.length > 0) {
        this.showPreview = true;
      }
    },

    removePreview: function (index) {
      this.order.splice(index, 1);
      if (this.order.length < 1) {
        this.showPreview = false;
      }
    },

    // 提交投注
    createOrder: function () {
      let _that = this;
      if (_that.order.length > 0) {
        let data = [];
        for (let i = 0; i < _that.order.length; i++) {
          data.push({
            id: _that.order[i][1].id,
            total: _that.order[i][2],
            data: [],
          });
        }
        _that.$parent.showLoading();
        _that.$apiFun
          .post("/api/lotteryOrder", {
            room_id: _that.room_id,
            order: data,
            expect: _that.opendata.nextexpect,
          })
          .then((res) => {
            if (res && res.code == 200) {
              _that.$parent.showTost(1, "下注成功");
              _that.applyBalance(res.data);
              _that.selectIds = [];
              _that.showPreview = false;
              _that.playbox = false;
              _that.reloadChat();
            } else {
              _that.$parent.showTost(0, (res && res.message) || "下注失败");
            }
            _that.$parent.hideLoading();
          })
          .catch(function () {
            _that.$parent.hideLoading();
            _that.$parent.showTost(0, "网络连接失败");
          });
      }
    },

    backhome: function () {
      window.location.href = "/";
    },

    applyBalance: function (data) {
      if (!data || data.balance == null) return;
      let info = {};
      try {
        info = JSON.parse(localStorage.getItem("userInfo") || "{}");
      } catch (e) {
        info = {};
      }
      info.balance = data.balance;
      localStorage.setItem("userInfo", JSON.stringify(info));
      this.$store.commit("changUserInfo");
    },

    openBetSlip: function () {
      this.moreShow = false;
      this.recentShow = true;
      this.loadBetSlip(this.betSlipRange || "today", 1);
      this.loadPendingBets();
    },

    loadRecent: function () {
      this.openBetSlip();
    },

    loadPendingBets: function () {
      var _that = this;
      _that.$apiFun
        .get("/api/lotteryRecent?room_id=" + _that.room_id + "&range=pending&page=1&page_size=30")
        .then(function (res) {
          if (res.code != 200) return;
          var data = res.data || {};
          _that.pendingList = data.list || [];
          if (data.user) _that.betSlipUser = data.user;
        });
    },

    loadBetSlip: function (range, page) {
      var _that = this;
      _that.betSlipRange = range || "today";
      _that.betSlipPage = page || 1;
      _that.$parent.showLoading();
      _that.$apiFun
        .get(
          "/api/lotteryRecent?room_id=" +
            _that.room_id +
            "&range=" +
            _that.betSlipRange +
            "&page=" +
            _that.betSlipPage +
            "&page_size=15"
        )
        .then(function (res) {
          _that.$parent.hideLoading();
          if (res.code != 200) {
            _that.$parent.showTost(0, res.message || "暂无记录");
            return;
          }
          var data = res.data || {};
          // 兼容旧接口数组
          if (Array.isArray(data)) {
            _that.recentList = data;
            _that.betSlipPages = 1;
            return;
          }
          if (data.user) _that.betSlipUser = data.user;
          if (_that.betSlipRange === "month30") {
            _that.monthStats = data.stats || {};
            _that.recentList = [];
          } else {
            _that.recentList = data.list || [];
            _that.betSlipPage = data.page || 1;
            _that.betSlipPages = data.pages || 1;
          }
          _that.recentShow = true;
        })
        .catch(function () {
          _that.$parent.hideLoading();
        });
    },

    sendMsg: function (closePad) {
      let _that = this;
      let text = (_that.keyboard || "").trim();
      if (!text) return;
      if (_that.isResting) {
        _that.$parent.showTost(0, _that.dailyRest.msg || "每日停盘休息，19:30开盘");
        return;
      }
      _that.$parent.showLoading();
      _that.$apiFun
        .post("/api/lotteryOrder", {
          room_id: _that.room_id,
          text: text,
          expect: _that.opendata ? _that.opendata.nextexpect : "",
        })
        .then((res) => {
          if (res && res.code == 200) {
            _that.keyboard = "";
            var isChat = !!(res.data && res.data.chat);
            var discarded = !!(res.data && res.data.discarded);
            if (isChat && discarded) {
              _that.$parent.showTost(1, "非下注内容已清除");
            } else if (isChat) {
              _that.$parent.showTost(1, "发送成功");
              _that.applyBalance(res.data);
              _that.reloadChat();
            } else {
              _that.$parent.showTost(1, "下注成功");
              _that.applyBalance(res.data);
              _that.reloadChat();
              if (closePad) _that.quickShow = false;
            }
          } else {
            _that.$parent.showTost(0, (res && res.message) || "下注失败");
          }
          _that.$parent.hideLoading();
        })
        .catch(function () {
          _that.$parent.hideLoading();
          _that.$parent.showTost(0, "网络连接失败");
        });
    },

    reloadChat: function () {
      this.chatdata = [];
      this.seenMsg = {};
      this.lastMsgId = 0;
      this.welcomePushed = false;
      this.getLottery();
    },

    myUserId: function () {
      var u = this.$store.state.userInfo || {};
      return u.id != null && u.id !== "" ? String(u.id) : "";
    },

    isMineUser: function (userId) {
      var me = this.myUserId();
      if (!me || userId == null || userId === "" || userId === 0 || userId === "0") return false;
      return String(userId) === me;
    },

    msgPush: function (msg) {
      var u = this.$store.state.userInfo || {};
      this.chatdata.push({
        left: 0,
        author: u.nickname || u.username || "",
        avatar: u.avatar || "/static/img/lottery/system.svg",
        content: msg,
        user_id: u.id,
      });
      this.$nextTick(() => this.scrollChatBottom(true));
    },

    msgReceive: function (id, author, avatar, msg) {
      this.chatdata.push({
        left: this.isMineUser(id) ? 0 : 1,
        author: author,
        avatar: avatar,
        content: msg,
        user_id: id,
      });
      this.$nextTick(() => this.scrollChatBottom(true));
    },

    getAmount: function () {
      let sum = 0;

      for (let i = 0; i < this.order.length; i++) {
        sum += parseFloat(this.order[i][2]);
      }

      return sum;
    },
  },
};
</script>

<style lang="scss" scoped>
.roombox {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .header {
    position: relative;
    width: 100%;
    height: 45px;
    flex-shrink: 0;
    background: #158bf4;
    z-index: 2005;

    .backbtn {
      position: absolute;
      width: 45px;
      height: 45px;
      top: 0;
      left: 0;
      align-content: center;
      text-align: center;
    }

    .room-name {
      position: absolute;
      left: 18%;
      width: 64%;
      height: 100%;
      line-height: 45px;
      text-align: center;
      color: #fff;
      font-size: 15px;
      font-weight: 600;
      letter-spacing: 0.2px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .kefu-btn {
      position: absolute;
      right: 8px;
      top: 0;
      height: 45px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 10px;
      line-height: 1.1;
      padding: 0 4px;
      gap: 1px;
    }
  }

  .panel {
    position: relative;
    width: 100%;
    height: auto;
    min-height: 0;
    flex-shrink: 0;
    background: #fff;
    padding-top: 8px;
    padding-bottom: 0;
    z-index: 2005;
    overflow: visible;

    .sbf {
      width: 100%;
      height: 52px;
      display: flex;
      border-bottom: 1px solid #edf0f7;

      .item {
        position: relative;
        width: 50%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        color: #1c263d;
      }

      .item:last-child {
        border-left: 1px solid #cdd1df;
      }

      .balance-item {
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
      }

      .nextexpect {
        margin-top: 2px;
        font-size: 13px;
        color: #000;
        font-weight: 500;
        line-height: 1.2;

        b {
          color: #68a6f7;
          font-weight: 500;
        }
      }

      .cutdown {
        margin-top: 4px;
        min-width: 68px;
        height: 24px;
        padding: 0 10px;
        background: #545974;
        text-align: center;
        border-radius: 4px;
        display: inline-flex;
        align-items: center;
        justify-content: center;

        .van-count-down {
          color: #fff;
          font-size: 14px;
          font-weight: 700;
          line-height: 24px;
        }

        b {
          color: #fff;
          font-size: 13px;
          font-weight: 700;
        }
      }

      .rest-status {
        margin-top: 4px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        line-height: 1;

        .rest-text {
          color: #e53935;
          font-size: 15px;
          font-weight: 700;
        }

        .rest-open {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          height: 20px;
          padding: 0 8px;
          border-radius: 10px;
          background: #ffe4ec;
          color: #e53935;
          font-size: 12px;
          font-weight: 600;
          white-space: nowrap;
        }
      }

      .title1 {
        margin-top: 2px;
        font-size: 13px;
        color: #000;
        font-weight: 500;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        line-height: 1.2;

        .bal-refresh {
          color: #9aa4b8;
        }
      }

      .wallet {
        margin-top: 6px;
        font-size: 15px;
        font-weight: 700;
        color: #e4593e;
        letter-spacing: 0.2px;
        line-height: 1.2;
      }
    }

    .info-bar {
      display: flex;
      align-items: stretch;
      width: 100%;
      min-height: 48px;
      padding: 6px 0;
      border-bottom: 1px solid #eef1f5;
      background: #fafbfd;
      box-sizing: border-box;

      .info-cell {
        flex: 1;
        text-align: center;
        border-right: 1px solid #eef1f5;
        padding: 2px 4px;
      }
      .info-cell:last-child {
        border-right: 0;
      }
      .info-label {
        font-size: 12px;
        color: #8a93a3;
        line-height: 1.3;
      }
      .info-val {
        margin-top: 2px;
        font-size: 14px;
        font-weight: 600;
        color: #243044;
        line-height: 1.3;
      }
      .info-val.up {
        color: #e85d4c;
      }
      .info-val.down {
        color: #069b71;
      }
    }

    .xbf-wrap {
      position: relative;
      z-index: 90;
      overflow: visible;
      line-height: 0;
    }

    .xbf {
      display: grid;
      grid-template-columns: 42% 1fr auto 18px;
      align-items: center;
      height: 42px;
      padding: 0 12px 0 0;
      margin: 0;
      box-sizing: border-box;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      background: #fff;
      border-bottom: 1px solid #edf0f7;
      color: #53607c;
      font-size: 14px;
      line-height: 1.2;

      &.open .result-caret {
        transform: rotate(180deg);
      }
      /* 关闭：向下▼；展开：向上▲ */

      .lastexpect {
        justify-self: start;
        margin-left: 14px;
        color: #1c263d;
        font-size: 14px;
        white-space: nowrap;

        b {
          color: #68a6f7;
          font-weight: 500;
        }
      }

      .open-balls {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        min-width: 0;

        em,
        b {
          width: 22px;
          height: 22px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          color: #fff;
          font-size: 11px;
          font-style: normal;
          font-weight: 700;
          line-height: 1;
          flex-shrink: 0;
        }
        em {
          background: linear-gradient(180deg, #6fc4ff, #3d8fee);
          box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.6);
        }
        b {
          background: linear-gradient(180deg, #ff7a8d, #e95873);
          box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.56);
        }
        i {
          color: #1c263d;
          font-size: 11px;
          font-style: normal;
          font-weight: 600;
        }
      }

      .combo-text {
        justify-self: end;
        color: #1c263d;
        font-size: 13px;
        font-weight: 500;
        white-space: nowrap;
        margin-right: 2px;
      }

      .result-caret {
        justify-self: end;
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 7px solid #8b93aa;
        border-bottom: 0;
        transition: transform 0.15s ease;
      }

      .opencode.l6hcode {
        display: flex;
        align-items: center;
        gap: 2px;
        grid-column: 2 / 4;

        div {
          width: 28px;
          height: 15px;
          .ball {
            width: 18px;
            height: 18px;
            color: #fff;
            border-radius: 50%;
            margin: 0 auto;
            font-size: 10px;
            line-height: 18px;
            text-align: center;
          }
          p {
            margin-block: 0 !important;
            font-size: 9px;
          }
        }
      }
    }

    .hist-panel {
      position: relative;
      z-index: 92;
      background: #fff;
      box-shadow: 0 8px 18px rgba(30, 42, 74, 0.18);
      border-bottom: 1px solid #e4e8f1;
      max-height: min(52vh, 380px);
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }

    .hist-tools {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 6px;
      padding: 8px 10px 4px;
      background: #fff;
      position: sticky;
      top: 0;
      z-index: 2;
      .ht {
        min-width: 36px;
        height: 26px;
        padding: 0 10px;
        border-radius: 6px;
        border: 1px solid #dbe3f0;
        background: #fff;
        color: #64748b;
        font-size: 13px;
        font-weight: 600;
        line-height: 24px;
        text-align: center;
        box-sizing: border-box;
        cursor: pointer;
        &.on {
          background: #5b8cff;
          border-color: #5b8cff;
          color: #fff;
        }
      }
    }

    .hist-head,
    .hist-row {
      display: grid;
      grid-template-columns: 58px 1fr 28px 28px 34px 36px 26px;
      align-items: center;
      padding: 0 10px;
      box-sizing: border-box;
    }

    .hist-head {
      position: sticky;
      top: 38px;
      z-index: 1;
      height: 30px;
      background: #eef2f8;
      border-bottom: 1px solid #dfe5ef;

      span {
        color: #7a8ba6;
        font-size: 11px;
        font-weight: 700;
        line-height: 1;
        text-align: center;
      }
      span:first-child {
        text-align: left;
      }
    }

    .hist-row {
      min-height: 34px;
      padding-top: 4px;
      padding-bottom: 4px;
      border-bottom: 1px solid #eef1f6;
      background: #fff;

      &:nth-child(even) {
        background: #f6f8fd;
      }

      .period {
        color: #30343b;
        font-size: 11px;
        font-weight: 800;
        white-space: nowrap;
      }

      .result {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 2px;
        min-width: 0;

        em,
        b {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          font-style: normal;
          font-weight: 800;
        }
        em {
          width: 18px;
          height: 18px;
          border-radius: 4px;
          background: #f4f4f4;
          color: #e98518;
          font-size: 11px;
        }
        i {
          color: #c8cdd8;
          font-size: 10px;
          font-style: normal;
          font-weight: 700;
        }
        b {
          width: 22px;
          height: 18px;
          border-radius: 4px;
          color: #fff;
          font-size: 11px;
          &.hot {
            background: #f03b32;
            box-shadow: 0 2px 5px rgba(240, 59, 50, 0.32);
          }
          &.cool {
            background: #3f8cdc;
            box-shadow: 0 2px 5px rgba(63, 140, 220, 0.32);
          }
        }
      }

      strong {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        justify-self: center;
        width: 20px;
        height: 18px;
        border-radius: 4px;
        color: #fff;
        font-size: 11px;
        font-weight: 800;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
        &.red {
          background: #f03b32;
        }
        &.blue {
          background: #3f8cdc;
        }
      }

      .extreme,
      .shape,
      .tail {
        justify-self: center;
        text-align: center;
        font-size: 11px;
        font-weight: 600;
        white-space: nowrap;
      }

      .tail {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background: #f0f3fa;
        color: #4a5568;
        font-size: 11px;
        font-weight: 800;
      }
    }

    .hist-empty {
      padding: 28px 0;
      color: #999;
      font-size: 13px;
      text-align: center;
    }
  }

  .chat-wrap {
    position: relative;
    width: 100%;
    flex: 1;
    min-height: 0;
    overflow: hidden;

    &.with-side {
      .chatbox {
        width: calc(100% - 72px);
        padding-right: 6px;
        box-sizing: border-box;
      }
      .scroll-bottom {
        right: 66px;
      }
    }
  }

  .side-fab {
    position: absolute;
    right: 4px;
    top: 6px;
    bottom: 40px;
    transform: none;
    z-index: 25;
    display: flex;
    flex-direction: column;
    gap: 5px;
    max-height: none;
    overflow-y: auto;
    padding: 2px 0;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    pointer-events: none;
    &::-webkit-scrollbar {
      width: 0 !important;
      display: none;
    }
    .fab-item {
      pointer-events: auto;
    }
  }

  .fab-item {
    position: relative;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.16);
    gap: 1px;
    flex-shrink: 0;

    span {
      font-size: 9px;
      line-height: 1;
      transform: scale(0.9);
    }

    .fab-dot {
      position: absolute;
      top: 1px;
      right: 1px;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #ef4444;
      border: 1px solid #fff;
    }

    &.fab-switch {
      background: #64748b;
    }
  }

  .scroll-bottom {
    position: absolute;
    right: 14px;
    bottom: 12px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #8b5cf6;
    box-shadow: 0 4px 12px rgba(107, 75, 183, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 20;
  }

  .chatbox {
    width: 100%;
    height: 100%;
    padding: 10px 10px 16px;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */

    &::-webkit-scrollbar {
      width: 0 !important;
      height: 0 !important;
      display: none;
      background: transparent;
    }

    .message {
      display: flex;
      width: 100%;
      margin-bottom: 10px;
      align-items: flex-start;

      .avatar {
        width: 44px;
        height: 44px;
        flex-shrink: 0;
        border-radius: 50%;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
        }
      }

      .content {
        margin-left: 8px;
        max-width: calc(100% - 56px);
        padding: 8px 12px;
        background: #fff;
        border: 1px solid #e8edf3;
        border-radius: 10px;
        color: #1f2937;
        font-size: 14px;
        line-height: 1.45;
        box-sizing: border-box;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);

        .nickname {
          font-size: 13px;
          color: #158bf4;
          font-weight: 600;
          margin-block-start: 0 !important;
          margin-bottom: 4px;
          width: 100%;
        }

        .msg-body {
          white-space: pre-wrap;
          word-break: break-word;
          font-size: 14px;

          &.welcome-line {
            display: flex;
            align-items: center;
            gap: 6px;
            color: #4c1d95;
            font-weight: 600;
            font-size: 13px;
            .welcome-ico {
              font-size: 14px;
              line-height: 1;
            }
          }
        }
      }
    }

    .message.sys {
      .content {
        max-width: calc(100% - 56px);
        background: #f8fafc;
        border: 1px solid #e2e8f0;
        .nickname {
          color: #6366f1;
          font-weight: 700;
          font-size: 13px;
        }
        .msg-body {
          font-size: 13px;
          line-height: 1.45;
          color: #334155;
          max-height: 42vh;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: none;
          -ms-overflow-style: none;

          &::-webkit-scrollbar {
            width: 0 !important;
            height: 0 !important;
            display: none;
          }
        }
      }

      .content.kk-rich {
        max-width: calc(100% - 52px);
        padding: 8px 8px 10px;
        background: #fff;
        border: 1px solid #e8edf3;
      }
    }

    .kk-card {
      width: 100%;
      box-sizing: border-box;
      font-size: 11px;
      color: #334155;
    }

    .kk-trend-head,
    .kk-trend-row {
      display: grid;
      grid-template-columns: 52px 1fr 28px 28px 28px 36px;
      gap: 2px;
      align-items: center;
      text-align: center;
    }
    .kk-trend-head {
      color: #94a3b8;
      font-size: 10px;
      padding-bottom: 4px;
      border-bottom: 1px solid #eef2f7;
      margin-bottom: 2px;
    }
    .kk-trend-row {
      padding: 3px 0;
      border-bottom: 1px dashed #f1f5f9;
      .te {
        font-size: 10px;
        color: #64748b;
        text-align: left;
        padding-left: 2px;
      }
      .nums {
        display: flex;
        justify-content: center;
        gap: 2px;
        i {
          display: inline-block;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          color: #fff;
          font-style: normal;
          font-size: 10px;
          line-height: 16px;
          font-weight: 700;
          background: #3b82f6;
          &.red { background: #ef4444; }
          &.blue { background: #3b82f6; }
          &.green { background: #22c55e; }
        }
      }
      .tema {
        display: inline-block;
        min-width: 22px;
        height: 18px;
        border-radius: 4px;
        color: #fff;
        font-size: 11px;
        font-weight: 700;
        line-height: 18px;
        background: #ef4444;
        &.blue { background: #3b82f6; }
        &.green { background: #22c55e; }
      }
      .tg {
        display: inline-block;
        min-width: 22px;
        height: 18px;
        border-radius: 3px;
        color: #fff;
        font-size: 10px;
        font-weight: 700;
        line-height: 18px;
        &.red { background: #ef4444; }
        &.blue { background: #3b82f6; }
      }
    }

    .kk-draw-title {
      color: #6b4bb7;
      font-size: 13px;
      font-weight: 700;
      margin-bottom: 8px;
    }
    .kk-draw-line {
      display: flex;
      align-items: center;
      gap: 4px;
      margin-bottom: 8px;
      em {
        font-style: normal;
        color: #94a3b8;
        font-size: 12px;
      }
      i {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-style: normal;
        font-weight: 700;
        border-radius: 50%;
      }
      .ball-sm {
        width: 22px;
        height: 22px;
        font-size: 11px;
        background: #3b82f6;
        &.red { background: #ef4444; }
        &.blue { background: #3b82f6; }
        &.green { background: #22c55e; }
      }
      .ball {
        width: 28px;
        height: 28px;
        font-size: 13px;
        background: #3b82f6;
        &.red { background: #ef4444; }
        &.blue { background: #3b82f6; }
        &.green { background: #22c55e; }
      }
    }
    .kk-draw-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
      margin-bottom: 8px;
      .tag {
        display: inline-block;
        padding: 2px 7px;
        border-radius: 4px;
        color: #fff;
        font-size: 11px;
        font-weight: 700;
        &.red { background: #ef4444; }
        &.blue { background: #3b82f6; }
        &.green { background: #22c55e; }
        &.purple { background: #8b5cf6; }
        &.gray { background: #94a3b8; }
      }
    }
    .kk-hist-label {
      font-size: 11px;
      color: #64748b;
      margin-bottom: 4px;
    }
    .kk-hist20 {
      display: grid;
      grid-template-columns: repeat(10, 1fr);
      gap: 3px;
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 24px;
        border-radius: 4px;
        color: #fff;
        font-size: 11px;
        font-weight: 700;
        &.blue { background: #3b82f6; }
        &.red { background: #ef4444; }
      }
    }

    .kk-streak-empty {
      color: #94a3b8;
      font-size: 12px;
      padding: 6px 0;
    }
    .kk-streak-row {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 4px 0;
      .sn {
        width: 40px;
        flex-shrink: 0;
        font-size: 12px;
        font-weight: 700;
        color: #334155;
      }
      .bar-wrap {
        flex: 1;
        height: 10px;
        background: #eef2f7;
        border-radius: 5px;
        overflow: hidden;
      }
      .bar {
        height: 100%;
        background: linear-gradient(90deg, #34d399, #10b981);
        border-radius: 5px;
      }
      .sc {
        width: 24px;
        text-align: right;
        font-size: 12px;
        font-weight: 700;
        color: #059669;
      }
    }

    .mine {
      flex-direction: row-reverse;
      justify-content: flex-start;
      .content {
        margin-left: 0;
        margin-right: 8px;
        background: #95ec69;
        border-color: #7fd956;
        box-shadow: none;
        .nickname {
          text-align: right;
          color: #3d6b2e;
        }
        .msg-body {
          text-align: left;
          color: #1a1a1a;
        }
      }
    }
  }

  .footer {
    width: 100%;
    height: 45px;
    flex-shrink: 0;
    position: relative;
    z-index: 30;
    background: #f7f8fa;

    .full-input {
      width: 95%;
      height: 45px;
      margin: 0 auto;
      background: #fff;
      border-radius: 22.5px;
      text-align: center;
      line-height: 45px;
      color: #d1d1d1;
      font-size: 0.45rem;
    }

    .active-input {
      background: #158bf4;
      color: #fff;
    }
  }

  .kk-footer {
    height: auto;
    min-height: 45px;
    flex-shrink: 0;
    background: #fff;
    border-top: 1px solid #e8edf3;
    padding: 6px 0 4px;
    box-sizing: border-box;
    position: relative;
    z-index: 40;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.04);

    &.fab-bottom {
      padding-top: 4px;
      background: linear-gradient(180deg, #f3eefc 0%, #ffffff 28px);

      .bottom-fab {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        gap: 6px;
        padding: 2px 8px 6px;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
        -ms-overflow-style: none;
        &::-webkit-scrollbar {
          width: 0 !important;
          height: 0 !important;
          display: none;
          background: transparent;
        }
      }
      .bfab {
        flex: 0 0 auto;
        height: 26px;
        border-radius: 13px;
        padding: 0 10px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 3px;
        box-sizing: border-box;
        white-space: nowrap;
        em {
          font-style: normal;
          font-size: 11px;
          font-weight: 600;
          line-height: 1;
          white-space: nowrap;
        }
        &.bfab-ico {
          width: 26px;
          height: 26px;
          padding: 0;
          border-radius: 50%;
          background: #5b8cff;
        }
        &.bfab-red {
          background: #f25b6a;
          color: #fff;
        }
        &.bfab-pink {
          background: #e879a9;
          color: #fff;
        }
        &.bfab-grad {
          background: linear-gradient(90deg, #5b8cff 0%, #8b5cf6 100%);
          color: #fff;
          padding: 0 12px;
        }
        &.bfab-ghost {
          background: #fff;
          color: #7c5cbf;
          border: 1px solid #c4b5fd;
        }
      }
    }

    .full-input {
      margin-bottom: 0;
    }

    .kk-input-row {
      display: flex;
      align-items: center;
      padding: 0 10px 6px;
      gap: 8px;
    }

    .order-input {
      flex: 1;
      height: 38px;
      border-radius: 19px;
      background: #f3f5f8;
      overflow: hidden;

      input {
        width: 100%;
        height: 100%;
        border: 0;
        background: transparent;
        box-shadow: none;
        box-sizing: border-box;
        padding: 0 14px;
        font-size: 0.34rem;
        color: #243044;
      }
    }

    .order-btn {
      flex-shrink: 0;
      width: 64px;
      height: 38px;
      background: #158bf4;
      color: #fff;
      border-radius: 19px;
      text-align: center;
      line-height: 38px;
      font-size: 0.36rem;
    }

    .kk-dock {
      display: flex;
      align-items: stretch;
      height: 48px;
      border-top: 1px solid #eef1f5;

      .dock-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #6b7280;
        font-size: 11px;
        font-weight: 500;
        gap: 2px;

        .van-icon {
          color: #6b7280;
        }

        &.on {
          color: #158bf4;
          font-weight: 700;
          .van-icon {
            color: #158bf4;
          }
        }
      }
    }
  }

  .betslip {
    height: 100%;
    background: #f5f6fa;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }
  .betslip-head {
    position: relative;
    height: 44px;
    line-height: 44px;
    text-align: center;
    background: #7c5cbf;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    .van-icon {
      position: absolute;
      right: 12px;
      top: 12px;
      font-size: 18px;
    }
  }
  .betslip-user {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    background: #fff;
    border-bottom: 1px solid #eef1f5;
  }
  .bu-name {
    font-size: 15px;
    font-weight: 700;
    color: #243044;
  }
  .bu-sub {
    margin-top: 2px;
    font-size: 12px;
    color: #8a93a3;
  }
  .bu-btn {
    padding: 6px 12px;
    border-radius: 14px;
    background: #efe8ff;
    color: #6b4bb7;
    font-size: 12px;
    font-weight: 600;
  }
  .betslip-section {
    background: #fff;
    margin-top: 8px;
    padding: 8px 10px 10px;
    &.grow {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
    }
  }
  .sec-title {
    font-size: 14px;
    font-weight: 700;
    color: #243044;
    margin-bottom: 8px;
    em {
      font-style: normal;
      color: #8a93a3;
      font-weight: 500;
      font-size: 12px;
    }
    &.tabs {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .tab-row {
    display: flex;
    gap: 6px;
    em {
      font-style: normal;
      font-size: 12px;
      padding: 3px 8px;
      border-radius: 10px;
      color: #6b7280;
      background: #f3f5f8;
      font-weight: 600;
      &.on {
        background: #7c5cbf;
        color: #fff;
      }
    }
  }
  .bet-table {
    display: grid;
    grid-template-columns: 1.1fr 1.2fr 1.4fr 0.9fr;
    gap: 4px;
    font-size: 12px;
    &.head {
      color: #8a93a3;
      padding: 4px 0 6px;
      border-bottom: 1px solid #eef1f5;
    }
    &.row {
      padding: 8px 0;
      border-bottom: 1px solid #f3f5f8;
      color: #243044;
      align-items: center;
      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .betslip-empty {
    text-align: center;
    color: #8a93a3;
    padding: 18px 0;
    font-size: 13px;
  }
  .win {
    color: #f59e0b;
    font-weight: 700;
  }
  .lose {
    color: #ef4444;
    font-weight: 700;
  }
  .pending {
    color: #6b4bb7;
  }
  .month-stats {
    padding: 8px 4px 16px;
  }
  .ms-row {
    display: flex;
    justify-content: space-between;
    padding: 10px 4px;
    border-bottom: 1px solid #eef1f5;
    label {
      color: #6b7280;
      font-size: 13px;
    }
    b {
      color: #243044;
      font-size: 14px;
    }
  }
  .bet-pager {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 12px;
    padding-bottom: 8px;
  }
  .pg-btn {
    min-width: 72px;
    height: 32px;
    line-height: 30px;
    text-align: center;
    border: 1px solid #7c5cbf;
    color: #7c5cbf;
    border-radius: 6px;
    font-size: 13px;
    &.off {
      opacity: 0.35;
      border-color: #c4c4c4;
      color: #999;
    }
  }
  .pg-num {
    color: #5b6575;
    font-size: 13px;
  }

  .l6hlist {
    padding-top: 5px;

    .row {
      height: 30px;

      div {
        float: left;
        width: 20%;
        text-align: center;
        line-height: 30px;
      }

      .opencode {
        width: 60%;
        display: flex;
        justify-content: center;

        div {
          width: 30px;
          height: 30px;

          .ball {
            width: 20px;
            height: 20px;
            line-height: 20px;
            color: #fff;
            border-radius: 50%;
            margin: 5px;
          }

          p {
            width: auto;
            margin-block: 0 !important;
          }
        }
      }
    }
  }

  .playbox {
    height: 100%;
    background: #fff;

    .header {
      position: relative;
      background: #fff;
      border-top: 1px solid #d1d1d1;
      border-bottom: 1px solid #d1d1d1;
      height: 40px;
      line-height: 40px;
      color: #000;
      text-align: center;
      font-size: 0.36rem;

      #closebtn {
        position: absolute;
        left: 10px;
        top: 10px;
      }
    }

    .body {
      width: 100%;
      height: calc(100% - 40px - 100px - 2px);
      background: #f5f7fa;
      display: flex;

      .left {
        width: 72px;
        height: 100%;
        background: #fff;
        overflow-y: auto;
        flex-shrink: 0;

        > div {
          width: 72px;
          height: 48px;
          line-height: 48px;
          text-align: center;
          border-bottom: 1px solid #eef1f5;
          font-size: 0.32rem;
          color: #5b6575;
        }

        .active {
          position: relative;
          background: #eef6ff;
          color: #158bf4;
          font-weight: 600;

          .active-flag {
            position: absolute;
            width: 3px;
            height: 50%;
            left: 0;
            top: 25%;
            background: #158bf4;
            border-radius: 0 2px 2px 0;
          }
        }
      }

      .right {
        width: calc(100% - 72px);
        height: calc(100% - 16px);
        padding: 8px 8px 8px 10px;
        box-sizing: border-box;

        .title {
          position: relative;
          height: 28px;
          line-height: 28px;
          font-weight: 700;
          font-size: 0.36rem;
          color: #243044;
          margin-bottom: 6px;
        }

        .plays {
          width: 100%;
          height: calc(100% - 34px);
          overflow-y: auto;
          display: flex;
          flex-wrap: wrap;
          align-content: flex-start;
          gap: 8px;

          .play-cell {
            float: none;
            width: calc(50% - 4px);
            height: auto;
            margin: 0;

            .btn {
              float: none;
              width: 100%;
              height: 54px;
              border: 1px solid #c5daf5;
              margin: 0;
              border-radius: 8px;
              text-align: center;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              background: #fff;
              box-sizing: border-box;
              color: #243044;

              .play-name {
                font-size: 16px;
                font-weight: 700;
                line-height: 1.2;
              }

              .play-odds {
                margin-top: 2px;
                font-size: 13px;
                color: #e85d4c;
                font-weight: 600;
              }
            }

            .active {
              background: #158bf4;
              border-color: #158bf4;
              color: #fff;
              .play-name,
              .play-odds {
                color: #fff;
              }
            }
          }

          &.cols-3 .play-cell {
            width: calc(33.333% - 6px);
            .btn {
              height: 50px;
              .play-name {
                font-size: 14px;
              }
            }
          }

          &.cols-4 .play-cell {
            width: calc(25% - 6px);
            .btn {
              height: 48px;
              .play-name {
                font-size: 13px;
              }
              .play-odds {
                font-size: 12px;
              }
            }
          }

          .special-nums {
            width: 100%;
            border-top: 1px dashed #158bf4;
            padding-top: 10px;
            display: flex;
            flex-wrap: wrap;
            gap: 6px;
          }

          .number {
            width: calc(14.28% - 6px);
            height: auto;

            .btn {
              width: 100%;
              height: 28px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 13px;
            }

            .active {
              background: #158bf4;
              color: #fff;
            }
          }
        }
      }
    }

    &.table {
      .body .right .plays {
        .play-cell .btn {
          height: 64px;
          border-width: 1.5px;
          .play-name {
            font-size: 18px;
          }
          .play-odds {
            font-size: 14px;
          }
        }
      }
    }

    .footer {
      width: 100%;
      height: 100px;

      .f1 {
        width: 100%;
        height: 25px;
        line-height: 25px;
        text-align: center;
        color: red;
      }

      .f2,
      .f3 {
        width: 100%;
        height: 40px;
        text-align: center;
      }

      .f2 {
        height: 30px;
        display: flex;
        justify-content: space-around;

        .trash {
          width: 10%;
          height: 30px;
          background: rgb(243, 246, 255);
          align-content: center;
          border-radius: 5px;
          border: 1px solid #d1d1d1;
        }

        .quick {
          width: 60%;
          height: 30px;
          background: rgb(243, 246, 255);
          border-radius: 5px;
          display: flex;
          border: 1px solid #d1d1d1;

          div {
            width: 20%;
            line-height: 30px;
            color: #000;
            border-right: 1px solid #d1d1d1;
          }

          div:last-child {
            border: 0;
          }
        }

        .input {
          width: 20%;
          height: 30px;
          background: rgb(243, 246, 255);
          border-radius: 5px;
          border: 1px solid #d1d1d1;

          input {
            width: 90%;
            height: 25px;
            box-shadow: none;
            box-sizing: unset;
            border-radius: 6px;
            font-size: 0.35rem;
            background: none;
            text-align: center;
            border: 0;
          }
        }
      }

      .f3 {
        display: flex;
        justify-content: space-around;

        .lastorder {
          width: 20%;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: rgb(243, 246, 255);
          border: 1px solid #d1d1d1;
          border-radius: 6px;
          margin-top: 10px;
        }

        .submitorder {
          width: 60%;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: #158bf4;
          color: #fff;
          border: 1px solid #d1d1d1;
          border-radius: 6px;
          margin-top: 10px;
        }
      }
    }
  }
}

.red {
  background: #ef4444 !important;
}

.blue {
  background: #3b82f6 !important;
}

.green {
  background: #22c55e !important;
}

.preview {
  padding: 10px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .p1 {
    width: 20%;
    text-align: center;
    padding: 2px 5px;
    background: #158bf4;
    color: #fff;
  }

  .p2 {
    color: #000;
    text-align: center;
    width: 40%;
  }

  .p3 {
    width: 30%;
    text-align: right;

    input {
      width: 55%;
      border: 1px solid #d1d1d1;
      box-shadow: none;
      box-sizing: unset;
      border-radius: 6px;
      text-indent: 15px;
      font-size: 0.3rem;
    }

    .remove {
      margin-left: 10px;
    }
  }
}

.kk-pad {
  height: 100%;
  background: #f2f3f7;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 8px 8px 10px;
}
.kk-pad-head {
  position: relative;
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  color: #243044;
  height: 28px;
  line-height: 28px;
  margin-bottom: 6px;
  .van-icon {
    position: absolute;
    right: 4px;
    top: 4px;
    color: #8a93a3;
  }
}
.kk-pad-input-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.kk-pad-input {
  flex: 1;
  min-width: 0;
  height: 36px;
  line-height: 36px;
  padding: 0 10px;
  background: #fff;
  border-radius: 8px;
  color: #243044;
  font-size: 15px;
  border: 1px solid #e3e8ef;
  outline: none;
  box-sizing: border-box;
}
.kk-pad-send {
  flex-shrink: 0;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  background: linear-gradient(90deg, #7a6cff, #5b4fd6);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}
.kk-tema-row {
  display: flex;
  overflow-x: auto;
  gap: 6px;
  padding-bottom: 8px;
  -webkit-overflow-scrolling: touch;
}
.tema-chip {
  flex: 0 0 auto;
  width: 42px;
  height: 40px;
  border-radius: 8px;
  background: #6b4bb7;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  b {
    font-size: 14px;
    line-height: 1.1;
  }
  em {
    font-style: normal;
    font-size: 10px;
    opacity: 0.9;
  }
}
.kk-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(6, 1fr);
  gap: 5px;
  min-height: 0;
}
.kk-cell {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: #243044;
  -webkit-tap-highlight-color: transparent;
  b {
    font-size: 14px;
    line-height: 1.15;
  }
  em {
    font-style: normal;
    font-size: 10px;
    color: #6b4bb7;
    margin-top: 1px;
    font-weight: 600;
  }
}
.kk-cell.play {
  color: #243044;
}
.kk-cell.num {
  font-size: 18px;
  font-weight: 700;
}
.kk-cell.amt {
  color: #e85d4c;
  font-size: 15px;
}
.kk-cell.ghost {
  background: #eef0f4;
  color: #5b6575;
  font-size: 12px;
  font-weight: 600;
}
.kk-cell.dark {
  background: #5b6575;
  color: #fff;
  border-color: #5b6575;
}
.kk-cell.confirm {
  background: #e85d4c;
  color: #fff;
  border-color: #e85d4c;
  font-size: 13px;
  font-weight: 700;
}
.kk-cell:active {
  opacity: 0.85;
  transform: scale(0.98);
}

.more-box {
  padding: 8px 0 18px;
  background: #f5f7fa;
}
.more-title {
  text-align: center;
  font-size: 14px;
  color: #8a93a3;
  padding: 8px 0 4px;
}
.more-item {
  margin: 0 12px 8px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  background: #fff;
  border-radius: 10px;
  font-size: 16px;
  color: #243044;
  font-weight: 600;
}
.more-item.cancel {
  color: #8a93a3;
  font-weight: 500;
  margin-top: 4px;
}

.kk-rules-popup {
  overflow: hidden;
}
.kk-rules {
  display: flex;
  flex-direction: column;
  max-height: 78vh;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
}
.kk-rules-hd {
  flex-shrink: 0;
  height: 44px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  background: linear-gradient(90deg, #5b8def 0%, #6b5bd6 100%);
  .van-icon {
    font-size: 18px;
    padding: 6px;
  }
}
.kk-rules-bd {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 12px 14px 18px;
  font-size: 13px;
  line-height: 1.65;
  color: #333;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    width: 0 !important;
    display: none;
  }
  p {
    margin: 0 0 4px;
  }
  hr {
    border: none;
    border-top: 1px solid #e8ecf2;
    margin: 8px 0;
  }
  b {
    color: #243044;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/lotteryPage.vue